import { Box } from "@mui/material";
import {
  GRID_AGGREGATION_FUNCTIONS_NO_LABEL,
  HotkeyCompliantDataGrid,
} from "components/common/dataGrid/HotkeyCompliantDataGrid";
import { GridColDef } from "@mui/x-data-grid-premium";
import { useTenantTranslation } from "hooks/formatters";
import { useMemo } from "react";
import { DeliveryAdjustmentMaterialItem } from "src/store/api/generatedApi";

interface DeliveryAdjustmentsGridProps {
  rows: DeliveryAdjustmentMaterialItem[];
  onProcessRowUpdate: (
    newRow: DeliveryAdjustmentMaterialItem
  ) => Promise<DeliveryAdjustmentMaterialItem>;
}

export const DeliveryAdjustmentsGrid = ({
  rows,
  onProcessRowUpdate,
}: DeliveryAdjustmentsGridProps) => {
  const { t } = useTenantTranslation();

  const columns: GridColDef<DeliveryAdjustmentMaterialItem>[] = useMemo(
    () => [
      {
        field: "material_name",
        headerName: t("material"),
        editable: false,
        width: 200,
      },
      {
        field: "quantity",
        headerName: t("adjustment"),
        type: "number",
        width: 200,
        editable: true,
      },
    ],
    [t]
  );

  return (
    <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
      <HotkeyCompliantDataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.material_name}
        processRowUpdate={onProcessRowUpdate}
        aggregationFunctions={GRID_AGGREGATION_FUNCTIONS_NO_LABEL}
        aggregationModel={{
          material_name: "size",
          quantity: "sum",
        }}
        cellSelection
        disableRowSelectionOnClick
        getCellClassName={() => "data-grid-cell"}
        sx={{
          maxHeight: "100%",
          "& .MuiDataGrid-cell--editing": {
            bgcolor: "background.paper",
            "& .MuiInputBase-root": {
              height: "100%",
            },
          },
          "& .data-grid-cell": {
            cursor: "cell",
          },
        }}
      />
    </Box>
  );
};
